module.exports = __webpack_public_path__ + "static/media/close-white.bb80402b.svg";